import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, TextField } from '@mui/material';
import DeleteIcon from '../../../../assets/images/deletePopup.svg';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
interface UnsavedChangesPopup {
  open: boolean;
  handleClose: () => void;
  handleConfirm: (data: any) => void;
  page: string;
}

const UnsavedChangesPopup= ({
  open,
  handleClose,
  handleNavigateClick
}:any) => {

  const handleCloseClick = () => {
 
    handleClose();
  };

  return (
    <Dialog
      className="renew-popup"
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title" className="renew_dialog-heading">
        Unsaved changes
      </DialogTitle>
      <DialogContent className="renew_dialog-content">
        <div className="renew_dialog-content-text">
          <div>
            <img src={DeleteIcon} alt={`Delete icon`} width="32" />
          </div>
       You have unsaved changes. If you leave this page now, your changes will be lost.
        </div>
  
      </DialogContent>
      <DialogActions>
        <div className="renew_dialog-actions">
          <Button
            onClick={handleNavigateClick}
            color="primary"
            variant="contained"
            className="renew-cancel-btn"
          >
            Discard Changes
          </Button>
          <Button
            onClick={handleCloseClick}
            color="primary"
            variant="contained"
            className="renew-active-btn"
       
          >
            Keep Editing
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

const MemoizedComponent = React.memo(UnsavedChangesPopup);
export default MemoizedComponent;
